module.exports = __webpack_public_path__ + "static/media/tablet.eb5e0212.jpg";